var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220.859 -36.131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.325,36.881a.752.752,0,0,0,.753.75h5.274v13h-5.274a.75.75,0,1,0,0,1.5h5.377a1.4,1.4,0,0,0,1.4-1.4V37.529a1.4,1.4,0,0,0-1.4-1.4h-5.377A.752.752,0,0,0,229.325,36.881Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.252,43.209a1.417,1.417,0,0,0-.381.927c0,.021-.012.04-.012.061a.618.618,0,0,0,.012.062,1.417,1.417,0,0,0,.381.927l2.957,3.077a.7.7,0,0,0,1.019,0,.771.771,0,0,0,0-1.061l-2.167-2.255h8.127a.751.751,0,0,0,0-1.5h-8.127l2.295-2.387a.773.773,0,0,0,0-1.061.7.7,0,0,0-1.019,0Z",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.79222df6.svg";
export { ForwardRef as ReactComponent };